import { render, staticRenderFns } from "./LettersSoundsSyllablesPreview.vue?vue&type=template&id=538324e8&lang=pug&"
import script from "./LettersSoundsSyllablesPreview.vue?vue&type=script&lang=js&"
export * from "./LettersSoundsSyllablesPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports